var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { sm: "12", md: "8" } },
            [_c("app-ubl-overview")],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "4" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(" " + _vm._s(_vm.$ct("dashboard.reports")) + " "),
                  ]),
                  _c(
                    "w-list",
                    [
                      _c("app-dashboard-report-item", {
                        attrs: { text: _vm.$ct("dashboard.balance") },
                        on: {
                          create: function ($event) {
                            return _vm.balanceReport($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: { text: _vm.$ct("dashboard.income-statement") },
                        on: {
                          create: function ($event) {
                            return _vm.incomeStatementReport($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: {
                          text: _vm.$ct("dashboard.income-statement-detail"),
                        },
                        on: {
                          create: function ($event) {
                            return _vm.incomeStatementDetailReport($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: { text: _vm.$ct("dashboard.bookkeeping-check") },
                        on: {
                          create: function ($event) {
                            return _vm.bookkeepingCheckReport($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: {
                          text: _vm.$ct("dashboard.purchase-journal-entries"),
                        },
                        on: {
                          create: function ($event) {
                            return _vm.purchaseJournalEntries($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: {
                          text: _vm.$ct("dashboard.sale-journal-entries"),
                        },
                        on: {
                          create: function ($event) {
                            return _vm.saleJournalEntries($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: {
                          text: _vm.$ct("dashboard.diverse-journal-entries"),
                        },
                        on: {
                          create: function ($event) {
                            return _vm.diverseJournalEntries($event)
                          },
                        },
                      }),
                      _c("app-dashboard-report-item", {
                        attrs: {
                          text: _vm.$ct("dashboard.bank-journal-entries"),
                        },
                        on: {
                          create: function ($event) {
                            return _vm.bankJournalEntries($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.customButtons.length > 0
                ? _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("custom-buttons-title")) + " "
                        ),
                      ]),
                      _c(
                        "w-list",
                        _vm._l(_vm.customButtons, function (btn, i) {
                          return _c(
                            "w-list-item",
                            { key: "cb-" + i },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: {
                                      icon: btn.Icon || "external-link-alt",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(btn.Name) + " "),
                              ]),
                              _c(
                                "w-list-item-action",
                                [
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: btn.Title || btn.Name,
                                          expression: "btn.Title || btn.Name",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.openCustomButton(btn)
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(" " + _vm._s(_vm.$ct("dashboard.actions")) + " "),
                  ]),
                  _c("w-card-content", [
                    _c("ul", { staticClass: "action-buttons" }, [
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openCreateVatDeclarationModal()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "fas" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("dashboard.create-vat-declaration")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openIntraConsignment()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "fas" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$ct("dashboard.intra-consignment")) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        [
                          _c(
                            "w-link",
                            { attrs: { to: "/diverse-ledgers" } },
                            [
                              _c("w-fa", {
                                attrs: { icon: "book", "ico-lib": "fas" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("dashboard.diverse-ledgers")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openLedgerAccountModal()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "far" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("dashboard.edit-ledger-accounts")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openCreateVatListingModal()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "far" },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$ct("dashboard.vat-listing")) + " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openCreateIntrastatModal()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "far" },
                          }),
                          _vm._v(" Intrastat "),
                        ],
                        1
                      ),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openDetailBrowse()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { icon: "book", "ico-lib": "far" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("dashboard.income-statement-detail")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _vm.winbooksActive
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.winbooksModal = true
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: {
                                  icon: "file-download",
                                  "ico-lib": "fas",
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("dashboard.export-winbooks")) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasFixedAssetsModule
                        ? _c(
                            "li",
                            [
                              _c(
                                "w-link",
                                { attrs: { to: "/fixed-assets" } },
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "book", "ico-lib": "fas" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct("dashboard.fixed-assets")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasFixedAssetsModule
                        ? _c(
                            "li",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.updateBookYearModal = true
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: "book", "ico-lib": "far" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$ct("dashboard.update-depreciations")
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.intraConsignmentModal,
            callback: function ($$v) {
              _vm.intraConsignmentModal = $$v
            },
            expression: "intraConsignmentModal",
          },
        },
        [
          _c("app-accounting-intra-consignment-modal", {
            on: {
              close: function ($event) {
                _vm.intraConsignmentModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.vatDeclarationModal,
            callback: function ($$v) {
              _vm.vatDeclarationModal = $$v
            },
            expression: "vatDeclarationModal",
          },
        },
        [
          _c("app-create-vat-declaration-modal", {
            on: {
              close: function ($event) {
                _vm.vatDeclarationModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.vatListingModal,
            callback: function ($$v) {
              _vm.vatListingModal = $$v
            },
            expression: "vatListingModal",
          },
        },
        [
          _c("app-vat-listing-modal", {
            on: {
              close: function ($event) {
                _vm.vatListingModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.intrastatModal,
            callback: function ($$v) {
              _vm.intrastatModal = $$v
            },
            expression: "intrastatModal",
          },
        },
        [
          _c("app-accounting-intrastat-modal", {
            on: {
              close: function ($event) {
                _vm.intrastatModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.winbooksModal,
            callback: function ($$v) {
              _vm.winbooksModal = $$v
            },
            expression: "winbooksModal",
          },
        },
        [
          _vm.winbooksModal
            ? _c("app-export-to-winbooks-modal", {
                on: {
                  close: function ($event) {
                    _vm.winbooksModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.updateBookYearModal,
            callback: function ($$v) {
              _vm.updateBookYearModal = $$v
            },
            expression: "updateBookYearModal",
          },
        },
        [
          _vm.updateBookYearModal
            ? _c("app-update-book-year-modal", {
                on: {
                  close: function ($event) {
                    _vm.updateBookYearModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.activeCustomButton
        ? _c("app-custom-button-modal", {
            attrs: { button: _vm.activeCustomButton },
            model: {
              value: _vm.showCustomButtonModal,
              callback: function ($$v) {
                _vm.showCustomButtonModal = $$v
              },
              expression: "showCustomButtonModal",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }